import { render, staticRenderFns } from "./video-play.vue?vue&type=template&id=468cf1d8&scoped=true&"
import script from "./video-play.vue?vue&type=script&lang=js&"
export * from "./video-play.vue?vue&type=script&lang=js&"
import style0 from "./video-play.vue?vue&type=style&index=0&id=468cf1d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468cf1d8",
  null
  
)

export default component.exports